import { api } from "@/lib/api-client";

export interface SubmitReviewPayload {
  order_ulid: string;
  store_rating?: number;
  store_comment?: string;
  agent_rating?: number;
  agent_comment?: string;
}

export interface SubmitReviewResponse {
  store_review: {
    ulid: string;
    rating: number;
    comment: string | null;
    status: string;
    receiver_type: string;
    store: { ulid: string; name: string } | null;
    agent: { ulid: string; name: string } | null;
  } | null;
  agent_review: {
    ulid: string;
    rating: number;
    comment: string | null;
    status: string;
    receiver_type: string;
    store: { ulid: string; name: string } | null;
    agent: { ulid: string; name: string } | null;
  } | null;
}

export const reviewService = {
  submit: (payload: SubmitReviewPayload, token?: string) =>
    api.post<SubmitReviewResponse>("/reviews", payload, { token }),
};
